(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initializeCarousel = (root) => {
    if (!root || root.dataset.jtOriginReady === 'true') return;

    const track = root.querySelector('[data-jt-origin-track]');
    const slides = Array.from(root.querySelectorAll('[data-jt-origin-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-jt-origin-dot]'));
    if (!track || slides.length < 2 || dots.length !== slides.length) return;

    root.dataset.jtOriginReady = 'true';
    const autoplay = root.dataset.jtOriginAutoplay === 'true';
    const interval = Math.max(Number(root.dataset.jtOriginInterval) || 5000, 3000);
    let activeIndex = 0;
    let autoplayTimer;
    let scrollTimer;

    const setActive = (index) => {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const goTo = (index, behavior = 'smooth') => {
      if (!mobileQuery.matches) return;
      const nextIndex = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[nextIndex].offsetLeft - track.offsetLeft,
        behavior
      });
      setActive(nextIndex);
    };

    const stopAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      stopAutoplay();
      if (!autoplay || !mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;
      autoplayTimer = window.setInterval(() => goTo(activeIndex + 1), interval);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goTo(index);
        startAutoplay();
      });
    });

    track.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const currentDistance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          const nearestDistance = Math.abs(slides[nearest].offsetLeft - track.offsetLeft - track.scrollLeft);
          return currentDistance < nearestDistance ? index : nearest;
        }, 0);
        setActive(nearestIndex);
      }, 80);
    }, { passive: true });

    track.addEventListener('pointerdown', stopAutoplay, { passive: true });
    track.addEventListener('pointerup', startAutoplay, { passive: true });
    track.addEventListener('pointercancel', startAutoplay, { passive: true });
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', startAutoplay);
    mobileQuery.addEventListener('change', startAutoplay);
    reducedMotionQuery.addEventListener('change', startAutoplay);
    startAutoplay();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-jt-origin-carousel]').forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
